export default __webpack_public_path__ + "static/media/press_1.c3f7ff80.webp";